import { all, takeLatest } from 'redux-saga/effects'
import service from '../../services/progressBar.service'
import { actions } from './ProgressBar.state'

let incrementIntervalId: number | null = null

function autoIncrement () {
  if (incrementIntervalId) return
  incrementIntervalId = window.setInterval(() => {
    if (service.state.progress === 100) {
      return clearIncrementInterval()
    }
    service.increment()
  }, service.incrementTime)
}

function clearIncrementInterval () {
  if (incrementIntervalId) clearInterval(incrementIntervalId)
}

function clearAutoIncrement () {
  if (service.state.active === 0) {
    clearIncrementInterval()
    service.setProgress(100)
    setTimeout(() => service.setProgress(0), service.incrementTime)
  }
}

export default function * effects () {
  yield all([
    takeLatest(actions.add, autoIncrement),
    takeLatest(actions.remove, clearAutoIncrement)
  ])
}
